import React from 'react';
import moment from 'moment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import useDictionary from '@ui/hooks/useDictionary';
import { size } from './size';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    label,
    id,
    timezone,
    value,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
}) => {
    const getWord = useDictionary();
    const _label = getWord(label);
    const getInput = (params: TextFieldProps) => {
        const props = {
            ...params,
            className: 'input',
            InputProps: {
                ...params.InputProps,
                placeholder: 'test',
                classes: {
                    input: 'date-input__text',
                },
            },
            InputLabelProps: {
                ...params.InputLabelProps,
                classes: {
                    root: 'date-input__label',
                },
            },
            label: _label,
            id,
            size: 'small' as size,
            onClick,
            onFocus,
            onKeyDown,
        };
        return (
            <>
                <TextField {...props} />
            </>
        );
    };

    if (lang === 'ru') {
        moment.updateLocale('ru', {
            weekdays: [
                'Воскресенье',
                'Понедельник',
                'Вторник',
                'Среда',
                'Четверг',
                'Пятница',
                'Суббота',
            ],
            weekdaysShort: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
        });
    } else {
        moment.updateLocale('en', {
            weekdays: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
            ],
            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        });
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} locale={lang}>
            <DatePicker
                renderInput={getInput}
                inputFormat="DD.MM.YYYY"
                mask="__.__.____"
                value={
                    value
                        ? value.add(value.utcOffset(), 'm').add(timezone, 'm')
                        : value
                }
                onChange={onChange}
                toolbarTitle={getWord('datePickerTitle')}
            />
        </LocalizationProvider>
    );
};

const DateInputComponent = React.memo(Component);

export default DateInputComponent;
